import {
    GET_ALL_QUOTES_BY_OPPURTUNITY,
    GET_ALL_OPPORTUNITY_BY_USER
} from '../ActionTypes/ActionTypes';


const initialState = {
    quotes: [],
    opp0rtunities:[],
};
function QuoteReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {


        case GET_ALL_QUOTES_BY_OPPURTUNITY:
            return {
                ...state,
                quotes: payload,
            };
        case GET_ALL_OPPORTUNITY_BY_USER:
            return {
                ...state,
                opp0rtunities: payload,
            };


        default:
            return state;
    }
};

export default QuoteReducer;